import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';
import { LocalLoadService } from '../../../shared/local-load.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-load-event-picture-upload',
  templateUrl: './load-event-picture-upload.component.html',
  styleUrls: ['./load-event-picture-upload.component.scss']
})
export class LoadEventPictureUploadComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  pictureShowed = false;

  pictureUrl: string;

  constructor(
    private localLoadService: LocalLoadService,
    private loader: LoaderService
  ) {
  }

  ngOnInit() {
  }

  showPicture() {
    this.pictureUrl    = `${this.localLoadService.getPictureRootUrl(this.event.relatedEntityId)}/inline`;
    this.pictureShowed = true;
  }

  downloadPicture() {
    this.loader.startLoad();

    this.localLoadService.downloadPicture(this.event.relatedEntityId)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe();
  }

}
